import SvgIcon from "@mui/material/SvgIcon";

function OutputIcon() {
  return (
    <SvgIcon fontSize="large">
      <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="3" y="3" width="26" height="26" rx="6" fill="black" />
        <path d="M10.9391 20L19.884 12H16.9744L8.05884 19.9724L8.0897 20H10.9391Z" fill="#92FFDD" />
        <path d="M15.0288 20L23.9723 12H21.0641L12.1486 19.9724L12.1794 20H15.0288Z" fill="#92FFDD" />
      </svg>
    </SvgIcon>
  );
}

export default OutputIcon;
